
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import { RuleGroup, Condition } from "@/types/conditions";
import DynamicDataFields from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFields.vue";
import DynamicDataDialog from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataDialog.vue";
import TemplateRuleGroupInput from "@/components/Reusable/CustomInputs/Conditions/TemplateRuleGroupInput.vue";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: {
    NiceButton,
    Icon,
    DynamicDataFields,
    DynamicDataDialog,
    TemplateRuleGroupInput
  }
})
export default class ConditionsMatrix extends Vue {
  @Prop()
  value!: RuleGroup[];

  @Prop()
  availableConditions!: Condition[];

  @Prop()
  templateTypes!: string[];
  /**
  THIS IS A HACK

  a template can only have one templateType
  various template rules are available or not based on the templateType
  the templateType is often the post type the template applies to

  we support multiple templateTypes here because we are using this as a "hack"
  to get the Conditions Matrix to work with the Query Builder control

  the Query Builder control incorrectly repurposes the templateType field
  to be the post type the user is querying, and since we can query multiple posts,
  we support multiple templateTypes here.

  this should be refactored at some point.

  ultimately, the conditions matrix should be abstracted enough to be able to be used for anything
  not just templates. The concept of a "template type" should be unknown to the conditions matrix.

  but, before we do this, we'll wait to understand the abstraction we really need for the conditions matrix
  until after we build popups, since that will also use the conditions matrix.
  */

  @Prop({ default: true })
  allowToAddCondition!: boolean;

  addRuleGroup() {
    const newRuleGroups = defensiveCopy(this.value);
    newRuleGroups.push([{}]);

    this.$emit("input", newRuleGroups);
  }

  deleteRuleGroup(groupIndex: number) {
    const newRuleGroups = defensiveCopy(this.value);
    newRuleGroups.splice(groupIndex, 1);

    this.$emit("input", newRuleGroups);
  }

  updateRuleGroup(newRuleGroup: RuleGroup, groupIndex: number) {
    const newRuleGroups = defensiveCopy(this.value);
    newRuleGroups[groupIndex] = newRuleGroup;

    this.$emit("input", newRuleGroups);
  }
}
